import { shiftParticipantHistoryEntityName, } from '../entities/shiftParticipantHistoryTypes';
export function getShiftParticipantHistoryStorage(context) {
    return context.storage(shiftParticipantHistoryEntityName);
}
